<script setup lang="ts">
// `belowBanner` drops the bar below the setup-mode banner (h-8) when it is showing.
withDefaults(defineProps<{ belowBanner?: boolean }>(), { belowBanner: false })
</script>

<template>
  <div class="fixed left-0 right-0 z-50 block bg-white/5 backdrop-blur" :class="belowBanner ? 'top-8' : 'top-0'">
    <div class="h-1 bg-gradient-to-r from-[#52B7B9] to-[#3783B0] opacity-90"></div>
  </div>
</template>
